<div class="Error-State">
  <ng-container >
    <coreui-error-state [header]="header" [subheader]="subhead" [illustration]="icon">
      {{content}}
    </coreui-error-state>
  </ng-container>
</div>
